import { authorizedRequest } from "utils/api";
import { getSessionCookie } from "utils/sessionCookie";

const uploadSourceFile = async (payload, method = "POST") => {
  const { type, name } = payload.file;

  const token = await getSessionCookie();
  const Authorization = `Bearer ${token}`;

  const headers = {
    "Content-Type": type,
    "Content-Disposition": `attachment; filename="${name}"`,
    Authorization
  };

  const formData = new FormData();
  formData.append("file", payload.file);
  formData.append("dealId", payload.dealId);
  formData.append("userId", payload.userId);
  formData.append("sourceId", payload.sourceId);
  formData.append("typeId", payload.typeId);
  formData.append("propertyId", payload.propertyId);
  formData.append("parentId", payload.parentId || "");
  formData.append("isPortfolioLevel", payload.isPortfolioLevel);
  formData.append("companyId", payload.companyId);

  return await authorizedRequest(payload.url, method, formData, headers, true);
};

export default uploadSourceFile;
